import React, { useEffect, useRef } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import InstagramVideo from './components/InstagramVideo';
import JoinUsOverview from './components/JoinUsOverview';
// import MediaShowcase from './components/MediaShowcase';
import Footer from './components/Footer';
import GoToTop from './components/GoToTop';
import TermsConditions from './components/TermsConditions';
import RefundReturns from './components/RefundReturns';
import PrivacyPolicy from './components/PrivacyPolicy';
import DeleteAccount from './components/DeleteAccount';
import MilkJourney from './components/MilkJourney/MilkJourney';
import JoinUs from './components/JoinUs';
import { LanguageProvider } from './LanguageContext';
// import LeadViewer from './components/LeadViewer';

declare global {
  interface Window {
    gtag?: (
      command: 'event',
      eventName: string,
      parameters: Record<string, string>,
    ) => void;
  }
}

const AnalyticsPageViews = () => {
  const location = useLocation();
  const lastTrackedPage = useRef('');

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}`;
    if (!window.gtag || lastTrackedPage.current === pagePath) return;

    lastTrackedPage.current = pagePath;
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
};

const AppContent = () => {
  return (
    <>
      <AnalyticsPageViews />
      <div className="App min-h-screen bg-white">
        <Header />
        <Routes>
          <Route path="/" element={
            <main>
              <Hero />
              <MilkJourney />
              <InstagramVideo />
              <JoinUsOverview />
              {/* <MediaShowcase /> */}
            </main>
          } />
          <Route path="/interests" element={<Navigate to="/" replace />} />
          <Route path="/join-us" element={<JoinUs role="producer" />} />
          <Route path="/join/producer" element={<JoinUs role="producer" />} />
          <Route path="/join/farmer" element={<JoinUs role="producer" />} />
          <Route path="/join/collector" element={<JoinUs role="collector" />} />
          <Route path="/join/distributor" element={<JoinUs role="distributor" />} />
          <Route path="/join/logistic" element={<JoinUs role="logistic" />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/terms_conditions" element={<TermsConditions />} />
          <Route path="/refund-returns" element={<RefundReturns />} />
          <Route path="/refund_returns" element={<RefundReturns />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/privacy_policy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/delete_account" element={<DeleteAccount />} />
          {/* Catch-all route - redirect unknown paths to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <GoToTop />
        {/* <LeadViewer /> */}
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </Router>
  );
}

export default App;
